import {
  selectCanShowPersonalizedAdsUnderGdpr,
  selectGdprApplies,
  selectIsOptedOutOfTargeting,
} from '../../selectors/app';

/**
 * Whether the user may be shown personalized ads, and so whether we may attach an identifier to an
 * ad request (`ppid`).
 *
 * Both signals are required under GDPR, and they are independent. `selectIsOptedOutOfTargeting` is
 * the CMP's targeting-cookies category; `selectCanShowPersonalizedAdsUnderGdpr` is the TCF ad
 * purposes. Measured from the EEA: switching the category off leaves all 11 TCF purposes `true` and
 * the TC string byte-identical, so a user can permit one and refuse the other. Checking only the
 * purposes — as this did — released a persistent identifier to users who had switched targeting
 * cookies off.
 *
 * Outside GDPR the category is the whole answer, and the conjunction reduces to it.
 */
export function canShowPersonalizedAds(state) {
  if (selectIsOptedOutOfTargeting(state)) {
    return false;
  }

  return selectGdprApplies(state) ? selectCanShowPersonalizedAdsUnderGdpr(state) : true;
}
